import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { Loader } from 'uikit';

import { useSystemInformationColumns } from './hooks/useSystemInformationColumns';
import { useSystemInformationData } from './hooks/useSystemInformationData';

import Styles from './SystemInformation.module.css';

export const SystemInformation = () => {
    const { columns } = useSystemInformationColumns();
    const { rowData, systemDataIsLoading } = useSystemInformationData();

    return (
        <main>
            <h2 className={Styles.title}>Информация о системе</h2>
            <section className={Styles.container}>
                {systemDataIsLoading && <Loader className={Styles.loader} />}
                <AgGridTable suppressNoRowsOverlay rowData={rowData} columnDefs={columns} />
            </section>
        </main>
    );
};

SystemInformation.displayName = 'SystemInformation';
